import TagAlertValue from '@/modules/core/models/TagAlertValue'

export default class ForeignHealthConfigurationTags {
  personalDataAlert?: TagAlertValue
  contactDataAlert?: TagAlertValue
  contactDataInsuredAlert?: TagAlertValue
  allYearAlert?: TagAlertValue
  personalDataInsuredAlert?: TagAlertValue
  allYearPassedDateAlert?: TagAlertValue
  moreInfoAlert?: TagAlertValue
  moreInfoStudyAlert?: TagAlertValue
  moreInfoLiveAlert?: TagAlertValue
  startDateTooltip?: TagAlertValue
  endDateTooltip?: TagAlertValue
  durationAlertStudent?: TagAlertValue
  durationAlertResident?: TagAlertValue
  durationAlertStudentMediator?: TagAlertValue
  durationAlertResidentMediator?: TagAlertValue

  constructor(data: any = {}) {
    if (data.personalDataAlert) this.personalDataAlert = new TagAlertValue(data.personalDataAlert)
    if (data.contactDataAlert) this.contactDataAlert = new TagAlertValue(data.contactDataAlert)
    if (data.allYearAlert) this.allYearAlert = new TagAlertValue(data.allYearAlert)
    if (data.contactDataInsuredAlert)
      this.contactDataInsuredAlert = new TagAlertValue(data.contactDataInsuredAlert)
    if (data.personalDataInsuredAlert)
      this.personalDataInsuredAlert = new TagAlertValue(data.personalDataInsuredAlert)
    if (data.allYearPassedDateAlert)
      this.allYearPassedDateAlert = new TagAlertValue(data.allYearPassedDateAlert)
    if (data.moreInfoAlert) this.moreInfoAlert = new TagAlertValue(data.moreInfoAlert)
    if (data.moreInfoStudyAlert) {
      this.moreInfoStudyAlert = new TagAlertValue(data.moreInfoStudyAlert)
    }
    if (data.moreInfoLiveAlert) {
      this.moreInfoLiveAlert = new TagAlertValue(data.moreInfoLiveAlert)
    }
    if (data.startDateTooltip) {
      this.startDateTooltip = new TagAlertValue(data.startDateTooltip)
    }
    if (data.endDateTooltip) {
      this.endDateTooltip = new TagAlertValue(data.endDateTooltip)
    }
    if (data.durationAlertStudent) {
      this.durationAlertStudent = new TagAlertValue(data.durationAlertStudent)
    }
    if (data.durationAlertStudentMediator) {
      this.durationAlertStudentMediator = new TagAlertValue(data.durationAlertStudentMediator)
    }
    if (data.durationAlertResident) {
      this.durationAlertResident = new TagAlertValue(data.durationAlertResident)
    }
    if (data.durationAlertResidentMediator) {
      this.durationAlertResidentMediator = new TagAlertValue(data.durationAlertResidentMediator)
    }
  }
}
